module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-error"
  }, [_c('div', {
    staticClass: "content-img-error"
  }, [_c('img', {
    attrs: {
      "src": '../../../static/img/' + _vm.codeError + '.svg',
      "width": "500px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-error-text row"
  }, [_c('div', {
    staticClass: "col-4 code-error"
  }, [_vm._v(_vm._s(_vm.codeError))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 text-error"
  }, [_vm._v("\n            " + _vm._s(_vm.$t("error." + _vm.codeError + ".error")) + " "), _c('br'), _vm._v("\n            " + _vm._s(_vm.$t("error." + _vm.codeError + ".errorText")) + "\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c3d0e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/Error.vue
// module id = 3151
// module chunks = 0